export enum Role {
  // Image Management
  technician = "technician", // can only uploadData
  qc = "qc", // manage image approve/reject image

  // Reseachers, all can do basic search and patient data or image lookup
  // has additional permissions for downloadData, accessRestrictedImages, accessReportBuilder
  researcher = "researcher",

  // Grading
  grader = "grader",
  // graderQC = 'graderQC', // grader and can approve/reject images
  // srGrader = 'srGrader', // grader's boss
  // clinicianReview = 'clinicianReview', // srGrader's boss

  // Utility Roles
  passwordReset = "passwordReset",
  establishNewPassword = "establishNewPassword",

  // User Admin/Lea
  admin = "admin",

  // System Admin
  sysadmin = "sysadmin"
}

export function getRoleForDisplay(role: string): string {
  const friendlyNames = {
    technician: "Technician",
    qc: "QC",

    researcher: "Researcher",

    grader: "Grader",
    // graderQC: 'Grader QC',
    // srGrader: 'Sr Grader',
    // clinicianReview: 'Clinician Review',

    passwordReset: null,
    establishNewPassword: null,

    admin: "Admin",

    sysadmin: null
  };

  return friendlyNames[role];
}
export function getRoleNameFromDisplay(role: string): string {
  const roleName = {
    "Technician": "technician",
    "QC": "qc",

    "Researcher": "researcher",

    "Grader": "grader",
    // 'Grader QC': "graderQC",
    // 'Sr Grader': "srGrader",
    // 'Clinician Review': "clinicianReview",

    "Admin": "admin",
  };

  return roleName[role];
}



// WEBPACK FOOTER //
// ./src/app/models/role.enum.ts